const DYE_TONES = [
  'white', 'orange', 'magenta', 'light_blue', 'yellow', 'lime', 'pink', 'gray',
  'light_gray', 'cyan', 'purple', 'blue', 'brown', 'green', 'red', 'black',
] as const;

const WOOL = [
  0xe9ecec, 0xf07613, 0xbd44b3, 0x3aafd9, 0xf8c627, 0x70b919, 0xed8dac, 0x3e4447,
  0x8e8e86, 0x158991, 0x792aac, 0x35399d, 0x724728, 0x546d1b, 0xa12722, 0x141519,
];

const CONCRETE = [
  0xcfd5d6, 0xe06101, 0xa9309f, 0x2489c7, 0xf1af15, 0x5ea918, 0xd5658f, 0x36393d,
  0x7d7d73, 0x157788, 0x64209c, 0x2d2f8f, 0x603c20, 0x495b24, 0x8e2121, 0x08090f,
];

const TERRACOTTA = [
  0xd1b2a1, 0xa05324, 0x95586c, 0x706b8a, 0xba8523, 0x677535, 0xa24e4e, 0x392a23,
  0x876a61, 0x575b5b, 0x7f3e59, 0x4a3b5b, 0x4c3123, 0x4c522a, 0x8e3c2e, 0x251610,
];

function byTone(colors: number[], suffix: string, target: Record<string, number>) {
  DYE_TONES.forEach((tone, index) => {
    target[`${tone}${suffix}`] = colors[index];
  });
}

/** ブロックテクスチャ名（Minecraftのファイル名に準拠）から基準色を引くための辞書。 */
export const textureBaseColors: Record<string, number> = {
  stone: 0x7d7d7d,
  smooth_stone: 0x9f9f9f,
  cobblestone: 0x7a7a7a,
  mossy_cobblestone: 0x6d7a5f,
  stone_bricks: 0x797979,
  mossy_stone_bricks: 0x6f7563,
  cracked_stone_bricks: 0x767676,
  chiseled_stone_bricks: 0x787878,
  granite: 0x95655a,
  polished_granite: 0x9b6a5d,
  diorite: 0xbfbfbc,
  polished_diorite: 0xc4c4c7,
  andesite: 0x88898a,
  polished_andesite: 0x8e9091,
  deepslate: 0x535254,
  cobbled_deepslate: 0x4f4f52,
  polished_deepslate: 0x494949,
  deepslate_bricks: 0x4a4a4d,
  deepslate_tiles: 0x373738,
  tuff: 0x6d6e64,
  calcite: 0xdfdedb,
  basalt: 0x4d4c53,
  blackstone: 0x2c2530,
  bedrock: 0x565656,
  gravel: 0x837f7e,
  netherrack: 0x6f3634,
  end_stone: 0xdbdfa1,
  end_stone_bricks: 0xdae0a4,
  purpur_block: 0xa97ca9,
  prismarine: 0x629f8c,
  dark_prismarine: 0x30786a,
  sandstone: 0xdbd3a2,
  red_sandstone: 0xb3561c,
  bricks: 0x97553a,
  nether_bricks: 0x2e161a,
  quartz_block: 0xecebe5,
  obsidian: 0x16121e,
  crying_obsidian: 0x23073f,

  dirt: 0x866043,
  coarse_dirt: 0x79553a,
  rooted_dirt: 0x906b4b,
  podzol: 0x59371a,
  mud: 0x3c3a3d,
  clay: 0xa4a8b8,
  farmland: 0x6f4c2b,
  grass_block: 0x7fb238,
  sand: 0xdbd3a0,
  red_sand: 0xbe6621,
  soul_sand: 0x4f3a2f,
  soul_soil: 0x4b3a2e,
  snow: 0xf0fafa,
  snow_block: 0xf0fafa,
  ice: 0x7dade9,
  packed_ice: 0x8ab5f0,
  blue_ice: 0x74a8f5,
  moss_block: 0x596d20,

  iron_block: 0xd8d8d8,
  gold_block: 0xf9ec4e,
  diamond_block: 0x62dbd5,
  emerald_block: 0x2fd35a,
  lapis_block: 0x1f4ba4,
  redstone_block: 0x971607,
  copper: 0xc16d51,
  copper_block: 0xc16d51,
  exposed_copper: 0xa07f68,
  weathered_copper: 0x6a9a78,
  oxidized_copper: 0x54a486,
  netherite_block: 0x453f42,
  coal_block: 0x101010,
  amethyst_block: 0x8464c8,
  raw_iron_block: 0xa9866a,
  raw_gold_block: 0xdda92e,
  raw_copper_block: 0x9c6a4f,

  glass: 0xd8ecef,
  water: 0x3f76e4,
  lava: 0xd45b12,
  glowstone: 0xf9d49c,
  sea_lantern: 0xb5cdc7,
  shroomlight: 0xf19858,
  ochre_froglight: 0xf0e3c4,
  verdant_froglight: 0xd3e0b0,
  pearlescent_froglight: 0xf0dfe8,
  redstone_lamp: 0x9c5f30,
  magma_block: 0x9d4c1c,

  hay_block: 0xa68d0d,
  bookshelf: 0x6f5739,
  crafting_table: 0x7a5228,
  furnace: 0x7a7a7a,
  bone_block: 0xe1ddca,
  melon: 0x6f8f1e,
  pumpkin: 0xc07615,
  barrel: 0x86633a,
  chest: 0xa06d29,
  scaffolding: 0xa17851,
  target: 0xd9c3ac,
  terracotta: 0x985e44,
  sponge: 0xc3c343,
  slime_block: 0x74bf68,
  honey_block: 0xfaa622,
  nether_wart_block: 0x730302,
  warped_wart_block: 0x1a7069,
  mushroom_stem: 0xcbc2b4,
  cobweb: 0xdcdcdc,
  vine: 0x51852b,
  lily_pad: 0x479c2f,
  torch: 0xf5b642,
  lantern: 0xd0803a,
  campfire_log: 0x6e4f2b,
  campfire_fire: 0xf59a23,
  soul_campfire_fire: 0x4fc3d9,

  tnt: 0xdb441a,
  observer: 0x6d6d6d,
  loom: 0x9c7b4e,
  composter: 0x7b5a34,
  beehive: 0xb4894f,
  cake: 0xf3e6d8,
  lectern: 0xa0703e,
  note_block: 0x654433,
  enchanting_table: 0x7d4b52,
  dirt_path: 0x8e7340,
  piston: 0x9a8873,
  dispenser: 0x7a7a7a,
  hopper: 0x4b4b4b,
  // コマンドブロック3種。教材では「むらさき＝リピート／みどり＝チェーン」で見分けさせるので
  // 実物の色をそのまま持たせ、向いている面だけ暗くして矢印の向きが分かるようにする。
  command_block: 0xc0764a,
  command_block_front: 0x8a5231,
  repeating_command_block: 0x7a5aa8,
  repeating_command_block_front: 0x513a75,
  chain_command_block: 0x4c8f79,
  chain_command_block_front: 0x2f5f51,
  // レッドストーン装置。教材で仕掛けの位置がひと目で分かるよう、面ごとに色を分けている。
  redstone_dust: 0x8f0f01,
  redstone_dust_on: 0xfa2c05,
  redstone_torch: 0xd7401f,
  redstone_torch_off: 0x7d5236,
  piston_top: 0xb2a17c,
  piston_top_sticky: 0x8b9c4c,
  piston_side: 0xa08a63,
  piston_bottom: 0x9a8873,
  piston_inner: 0x6d5b3d,
  dispenser_front: 0x555555,
  dropper: 0x7a7a7a,
  dropper_front: 0x555555,
  tripwire: 0xd3cec6,
  tripwire_hook: 0xa8834c,
  lever: 0x7f6a4d,
  repeater: 0xa3a3a3,
  comparator: 0xa3a3a3,
  rail: 0x9a7f4a,
  powered_rail: 0xa8862f,
  detector_rail: 0x9a7f4a,
  activator_rail: 0x8c6f45,
  daylight_detector: 0x8a7550,
  anvil: 0x4b4b4b,
  cauldron: 0x4b4b4b,
  smithing_table: 0x3f3c3d,
  grindstone: 0x8a8a8a,
  stonecutter: 0x7a7a7a,
  bell: 0xf2c64d,
  respawn_anchor: 0x3d2a5e,
  lodestone: 0x969a9c,
  spawner: 0x1a2733,
  red_mushroom_block: 0xc93c3b,
  brown_mushroom_block: 0x8f6b4d,
  dried_kelp_block: 0x39492b,
  sculk: 0x0e1a1d,
  reinforced_deepslate: 0x5a5c56,
  ancient_debris: 0x5e4139,
  gilded_blackstone: 0x392f30,
  mud_bricks: 0x8a6a53,
  packed_mud: 0x9a6f4e,
  mycelium: 0x6f6265,
  // 1.21 Tricky Trials
  copper_bulb: 0xc66e4e,
  chiseled_copper: 0xc16d51,
  copper_grate: 0xb4664b,
  tuff_bricks: 0x56564e,
  polished_tuff: 0x61625a,
  chiseled_tuff: 0x5d5e56,
  crafter: 0x7b5a3f,
  trial_spawner: 0x303b40,
  vault: 0x3d4a52,
  heavy_core: 0x35383e,

  // 1.21.4 The Garden Awakens
  pale_moss_block: 0x8f9a80,
  pale_moss_carpet: 0x8f9a80,
  pale_hanging_moss: 0x8f9a80,
  resin_block: 0xd97b1f,
  resin_bricks: 0xc96f1c,
  resin_clump: 0xe08a2c,
  creaking_heart: 0x4a3b2e,

  // 1.21.5 Spring to Life
  bush: 0x5f8f3e,
  firefly_bush: 0x4f7a35,
  cactus_flower: 0xe58fb5,
  leaf_litter: 0x8a6a3c,
  wildflowers: 0xd8c04a,
  short_dry_grass: 0xb8a05c,
  tall_dry_grass: 0xb8a05c,
  dried_ghast: 0xd9d2c4,

  // 26.x Chaos Cubed（sulfur caves）
  sulfur_block: 0xe0d040,
  sulfur_spike: 0xddd050,
  cinnabar: 0xb8342c,
  polished_cinnabar: 0xc03a30,
  cinnabar_bricks: 0xac3028,
  chiseled_cinnabar: 0xb43429,

  short_grass: 0x7fb238,
  tall_grass: 0x7fb238,
  fern: 0x7fb238,
  poppy: 0xd52f27,
  dandelion: 0xf1d94b,
  blue_orchid: 0x2ea9d4,
  allium: 0xb87fd6,
  cornflower: 0x4f6fd4,
  oxeye_daisy: 0xf0f0e0,
};

/** 木材ごとの板・樹皮・年輪の色。 */
export const woodTones: Record<string, { planks: number; bark: number; core: number }> = {
  oak: { planks: 0xb08a56, bark: 0x6b5330, core: 0xb08a56 },
  spruce: { planks: 0x6f5434, bark: 0x3b2a17, core: 0x745a37 },
  birch: { planks: 0xc8b17d, bark: 0xd7d2cc, core: 0xc8b17d },
  jungle: { planks: 0xa7724b, bark: 0x55431e, core: 0xa7724b },
  acacia: { planks: 0xb3623a, bark: 0x696254, core: 0xae5c25 },
  dark_oak: { planks: 0x4b3722, bark: 0x3c2d19, core: 0x4b3722 },
  mangrove: { planks: 0x773934, bark: 0x524323, core: 0x773934 },
  cherry: { planks: 0xe2b8a4, bark: 0x55343f, core: 0xe2b8a4 },
  pale_oak: { planks: 0xe0dad2, bark: 0xdcd9d2, core: 0xe0dad2 },
  bamboo: { planks: 0xc8a951, bark: 0x7c9a3c, core: 0xc8a951 },
  crimson: { planks: 0x683148, bark: 0x5c2635, core: 0x683148 },
  warped: { planks: 0x29757a, bark: 0x3a4f4f, core: 0x29757a },
};

/** 鉱石ブロックの母岩と鉱石粒の色。 */
export const oreTones: Record<string, number> = {
  coal: 0x1a1a1a,
  iron: 0xd8af93,
  copper: 0xd6764c,
  gold: 0xfcee4b,
  redstone: 0xaa0f01,
  lapis: 0x2b53c4,
  diamond: 0x5decf5,
  emerald: 0x17dd62,
  quartz: 0xebe3dc,
};

byTone(WOOL, '_wool', textureBaseColors);
byTone(WOOL, '_carpet', textureBaseColors);
byTone(CONCRETE, '_concrete', textureBaseColors);
byTone(CONCRETE, '_concrete_powder', textureBaseColors);
byTone(TERRACOTTA, '_terracotta', textureBaseColors);
byTone(TERRACOTTA, '_glazed_terracotta', textureBaseColors);
byTone(WOOL, '_stained_glass', textureBaseColors);
byTone(WOOL, '_shulker_box', textureBaseColors);

Object.entries(woodTones).forEach(([wood, tone]) => {
  textureBaseColors[`${wood}_planks`] = tone.planks;
  textureBaseColors[`${wood}_log`] = tone.bark;
  textureBaseColors[`${wood}_log_top`] = tone.core;
  textureBaseColors[`${wood}_stem`] = tone.bark;
  textureBaseColors[`${wood}_stem_top`] = tone.core;
});

Object.entries(oreTones).forEach(([ore, color]) => {
  textureBaseColors[`${ore}_ore`] = color;
  textureBaseColors[`deepslate_${ore}_ore`] = color;
});

/** バイオーム着色に相当する葉の色。Minecraftの平原バイオーム相当に寄せている。 */
export const leafTones: Record<string, number> = {
  oak: 0x59ae30,
  spruce: 0x4b7d4b,
  birch: 0x80a755,
  jungle: 0x30bb0b,
  acacia: 0x5ba428,
  dark_oak: 0x439122,
  mangrove: 0x53a534,
  cherry: 0xf0b1c8,
  pale_oak: 0xb5c9b0,
  azalea: 0x667e2f,
  flowering_azalea: 0x6f8b3a,
};
